import type { StackProps, TypographyProps } from "@mui/material";
import type { GridBasicGroupNode, GridRowId } from "@mui/x-data-grid-premium";
import { useGridApiContext } from "@mui/x-data-grid-premium";
import { getRowNode } from "@entrilia/shared/utilities/dataGridApiHelper.ts";
import type { TabularDataCell, TabularRow } from "../../../../../../../api/types/svTypes.ts";
import { buildTabularCell } from "./utils/buildTabularCell.tsx";
import { getCellFromRow, getFormattedValueWithFallback } from "./utils/dimension-column/buildDimensionColumnHelper.ts";

interface GroupingCellProps {
  id: GridRowId;
  rowNode: GridBasicGroupNode;
  containerProps?: StackProps;
  typographyProps?: TypographyProps;
}

export const GroupingCell = ({ id, rowNode, containerProps, typographyProps }: GroupingCellProps) => {
  const gridApi = useGridApiContext();

  const handleToggle = () => {
    gridApi.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
  };

  let childRowId = rowNode.children[0];
  const groupRow = gridApi.current.getRow<TabularRow>(id);
  let cell: TabularDataCell | undefined = groupRow?.groupField
    ? getCellFromRow(groupRow, groupRow.groupField)
    : undefined;
  while (!cell && childRowId !== undefined) {
    const node = getRowNode(gridApi, childRowId);
    if (node?.type === "leaf") {
      const childRow = gridApi.current.getRow<TabularRow>(childRowId);
      cell = childRow ? getCellFromRow(childRow, rowNode.groupingField ?? "") : undefined;
      break;
    } else if (node?.type === "group") {
      childRowId = node.children[0];
    } else {
      break;
    }
  }

  return buildTabularCell({
    cellType: "group",
    cell,
    formattedValue: getFormattedValueWithFallback(cell),
    typographyProps,
    containerProps,
    showGroupingToggle: true,
    groupingToggleProps: {
      expanded: rowNode.childrenExpanded === true,
      onToggle: handleToggle,
    },
  });
};

export default GroupingCell;
